import { COLOURS } from '../styles';
import { CRC8_POLY } from '../utils/crc8';

export const modelTypeItems = {
  all: 0,
  aquatek: 1,
  theralink: 2,
  oasis: 3,
  pooltek: 4,
  henden: 5,
};

export const controller_t = {
  NONE: 0x0000,
  AQUATEK: 0x0001,
  THERALINK: 0x0002,
  OASIS: 0x0006,
  AQUALIGHT: 0x0008,
  RECLAIM: 0x0009,
  POOLTEK: 0x000a,
  HENDEN: 0x000b,
  SUMMERTIME: 0x000c,
  SWC_DONTEK: 0x000d,
  SWC_HENDEN: 0x000e,
  INSTATOUCH_WIFI: 0x000f,
};

export const mType_label_t = {
  NONE: 'None',
  AQUATEK: 'Aquatek',
  THERALINK: 'Theralink',
  OASIS: 'Oasis',
  AQUALIGHT: 'Aqualight',
  RECLAIM: 'Reclaim',
  POOLTEK: 'Pooltek',
  HENDEN: 'Henden',
  SUMMERTIME: 'Chilli',
  SWC_DONTEK: 'SWC_Dontek',
  SWC_HENDEN: 'SWC_Henden',
  INSTATOUCH_WIFI: 'InstaTouch Wifi',
};

export const modelTypeDetails_no_SWC = [
  { value: controller_t.NONE, label: mType_label_t.NONE, crc_value: CRC8_POLY.CRC8, colour: COLOURS.error },
  {
    value: controller_t.AQUATEK,
    label: mType_label_t.AQUATEK,
    crc_value: CRC8_POLY.AQUATEK,
    colour: COLOURS.modelAquatek,
  },
  {
    value: controller_t.THERALINK,
    label: mType_label_t.THERALINK,
    crc_value: CRC8_POLY.THERALINK,
    colour: COLOURS.modelThrealux,
  },
  { value: controller_t.OASIS, label: mType_label_t.OASIS, crc_value: CRC8_POLY.OASIS, colour: COLOURS.modelOASIS },
  {
    value: controller_t.AQUALIGHT,
    label: mType_label_t.AQUALIGHT,
    crc_value: CRC8_POLY.AQUALIGHT,
    colour: COLOURS.modelAqualight,
  },
  {
    value: controller_t.RECLAIM,
    label: mType_label_t.RECLAIM,
    crc_value: CRC8_POLY.RECLAIM,
    colour: COLOURS.modelReclaim,
  },
  {
    value: controller_t.POOLTEK,
    label: mType_label_t.POOLTEK,
    crc_value: CRC8_POLY.POOLTEK,
    colour: COLOURS.modelPooltek,
  },
  { value: controller_t.HENDEN, label: mType_label_t.HENDEN, crc_value: CRC8_POLY.HENDEN, colour: COLOURS.modelHenden },
  {
    value: controller_t.SUMMERTIME,
    label: mType_label_t.SUMMERTIME,
    crc_value: CRC8_POLY.SUMMERTIME,
    colour: COLOURS.modelSummertime,
  },
];

export const modelTypeDetails = [
  { value: controller_t.NONE, label: mType_label_t.NONE, crc_value: CRC8_POLY.CRC8, colour: COLOURS.error },
  {
    value: controller_t.AQUATEK,
    label: mType_label_t.AQUATEK,
    crc_value: CRC8_POLY.AQUATEK,
    colour: COLOURS.modelAquatek,
  },
  {
    value: controller_t.THERALINK,
    label: mType_label_t.THERALINK,
    crc_value: CRC8_POLY.THERALINK,
    colour: COLOURS.modelThrealux,
  },
  { value: controller_t.OASIS, label: mType_label_t.OASIS, crc_value: CRC8_POLY.OASIS, colour: COLOURS.modelOASIS },
  {
    value: controller_t.AQUALIGHT,
    label: mType_label_t.AQUALIGHT,
    crc_value: CRC8_POLY.AQUALIGHT,
    colour: COLOURS.modelAqualight,
  },
  {
    value: controller_t.RECLAIM,
    label: mType_label_t.RECLAIM,
    crc_value: CRC8_POLY.RECLAIM,
    colour: COLOURS.modelReclaim,
  },
  {
    value: controller_t.POOLTEK,
    label: mType_label_t.POOLTEK,
    crc_value: CRC8_POLY.POOLTEK,
    colour: COLOURS.modelPooltek,
  },
  { value: controller_t.HENDEN, label: mType_label_t.HENDEN, crc_value: CRC8_POLY.HENDEN, colour: COLOURS.modelHenden },
  {
    value: controller_t.SUMMERTIME,
    label: mType_label_t.SUMMERTIME,
    crc_value: CRC8_POLY.SUMMERTIME,
    colour: COLOURS.modelSummertime,
  },
  {
    value: controller_t.SWC_DONTEK,
    label: mType_label_t.SWC_DONTEK,
    crc_value: CRC8_POLY.SWC_DONTEK,
    colour: COLOURS.modelAquatek,
  },
  {
    value: controller_t.SWC_HENDEN,
    label: mType_label_t.SWC_HENDEN,
    crc_value: CRC8_POLY.SWC_HENDEN,
    colour: COLOURS.modelSummertime,
  },
  {
    value: controller_t.INSTATOUCH_WIFI,
    label: mType_label_t.INSTATOUCH_WIFI,
    crc_value: CRC8_POLY.INSTATOUCH_WIFI,
    colour: COLOURS.modelAquatek,
  },
];

export const accessLevels = {
  guest: 0,
  admin: 1,
  super: 2,
  service: 3,
  installer: 4,
};

export const groups = {
  Admin: 1,
  Dontek: 2,
  Oasis: 3,
  Theralux: 4,
  Henden: 5,
  Waterco: 6,
  SummerTime: 7,
};

export const groups_table = {
  admin: groups.Admin,
  dontek: groups.Dontek,
  oasis: groups.Oasis,
  theralux: groups.Theralux,
  henden: groups.Henden,
  waterco: groups.Waterco,
  summertime: groups.SummerTime,

  1: 'admin',
  2: 'dontek',
  3: 'oasis',
  4: 'theralux',
  5: 'henden',
  6: 'waterco',
  7: 'summertime',
};
